if (!customElements.get('erya-sticky-buy')) {
  customElements.define('erya-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.abort = new AbortController();
      this.explicitChoice = this.dataset.singleVariant === 'true';
      this.action = this.querySelector('[data-cro-submit]');
      this.choice = this.querySelector('[data-cro-choice]');
      this.price = this.querySelector('[data-cro-price]');
      this.variant = this.querySelector('[data-cro-variant]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.update = this.update.bind(this);
      this.queue = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); };
      const signal = this.abort.signal;
      window.addEventListener('scroll', this.queue, { passive: true, signal });
      window.addEventListener('resize', this.queue, { passive: true, signal });
      this.root.addEventListener('change', (event) => { if (event.target.closest('variant-selects')) this.explicitChoice = true; this.queue(); }, { signal });
      this.root.addEventListener('click', (event) => { if (event.target.closest('variant-selects input[type="radio"]')) this.explicitChoice = true; this.queue(); }, { signal });
      this.choice.addEventListener('click', (event) => { event.preventDefault(); this.focusSelection(); }, { signal });
      this.action.addEventListener('click', () => {
        this.findControls();
        if (!this.explicitChoice || this.nativeButton?.disabled || this.nativeButton?.getAttribute('aria-disabled') === 'true') { this.focusSelection(); return; }
        if (this.form && this.nativeButton) {
          this.submittedFromSticky = true;
          this.form.requestSubmit(this.nativeButton);
        }
      }, { signal });
      this.observer = new MutationObserver((records) => { if (records.some((record) => !this.contains(record.target))) this.queue(); });
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value', 'checked', 'class'] });
      this.update();
    }
    findControls() {
      this.nativeButton = this.root.querySelector('[id^="ProductSubmitButton-"]');
      this.form = this.nativeButton?.form;
    }
    update() {
      this.findControls();
      if (!this.nativeButton || !this.form) {
        this.hidden = true;
        document.body.classList.toggle('erya-cro-sticky-is-visible', Boolean(document.querySelector('erya-sticky-buy:not([hidden])')));
        return;
      }
      const busy = this.nativeButton.classList.contains('loading');
      const available = !this.nativeButton.disabled && this.nativeButton.getAttribute('aria-disabled') !== 'true';
      const hasOptions = Boolean(this.root.querySelector('variant-selects'));
      const rootRect = this.root.getBoundingClientRect();
      const buyRect = this.nativeButton.getBoundingClientRect();
      const isVisible = this.mobile.matches && (available || hasOptions) && rootRect.top < window.innerHeight && !(buyRect.top >= 0 && buyRect.bottom <= window.innerHeight);
      this.hidden = !isVisible;
      document.body.classList.toggle('erya-cro-sticky-is-visible', isVisible);
      this.action.disabled = busy || (!available && !hasOptions);
      this.action.setAttribute('aria-busy', String(busy));
      this.action.textContent = busy ? this.dataset.loading : !available && !hasOptions ? this.nativeButton.querySelector('span')?.textContent.trim() : !this.explicitChoice ? this.dataset.choose : available ? this.dataset.add : this.dataset.change;
      if (this.submittedFromSticky && !busy) {
        this.submittedFromSticky = false;
        const error = this.nativeButton.closest('product-form')?.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (error?.textContent.trim()) {
          error.setAttribute('tabindex', '-1');
          error.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          error.focus({ preventScroll: true });
        }
      }
      const price = this.root.querySelector('[id^="price-"] .price-item--sale')?.closest('.price--on-sale') ? this.root.querySelector('[id^="price-"] .price-item--sale') : this.root.querySelector('[id^="price-"] .price__regular .price-item--regular');
      if (price) this.price.textContent = price.textContent.trim();
      const selected = [...this.root.querySelectorAll('variant-selects input:checked, variant-selects select option:checked')].map((item) => item.value).filter(Boolean);
      this.variant.hidden = !hasOptions;
      this.variant.textContent = selected.length ? selected.join(' / ') + ' · ' + this.dataset.edit : this.dataset.edit;
    }
    focusSelection() {
      const options = this.root.querySelector('variant-selects');
      const target = options || this.nativeButton;
      if (!target) return;
      target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      const control = options?.querySelector('input:checked, select, input') || this.nativeButton;
      control?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      document.body.classList.toggle('erya-cro-sticky-is-visible', Boolean(document.querySelector('erya-sticky-buy:not([hidden])')));
    }
  });
}
if (!window.eryaCroDetailsBound) {
  window.eryaCroDetailsBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cro-open-detail]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault(); target.open = true;
    target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    target.querySelector('summary')?.focus({ preventScroll: true });
  });
}
